module.exports = __webpack_public_path__ + "media/0003.9cb2acd6.mp3";